module.exports = __webpack_public_path__ + "img/1F1EE-1F1F9.3b8d29da.svg";